/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('remit');
const REMIT_LIST = "REMIT_LIST";
const REMIT_ADD = "REMIT_ADD";
const REMIT_DELETE = "REMIT_DELETE";
const REMIT_EDIT = "REMIT_EDIT";
const REMIT_DETAIL = "REMIT_DETAIL";
const REMIT_ORDER = "REMIT_ORDER";
const REMIT_EXPORT = "REMIT_EXPORT";

export default {
    REMIT_EXPORT,
    remitExport:()=>{
        return ajaxCommon({
            api:{
                url:'/api/remit/export',
                method:'post'
            },
            success:(data)=>({
                type:REMIT_EXPORT,
                data
            })
        })
    },
    REMIT_ORDER,
    remitForOrder:(id)=>{
        return ajaxCommon({
            api:{
                url:'/api/remit/order/' + id,
                method:'get'
            },
            success:(data)=>({
                type:REMIT_ORDER,
                data
            })
        })
    },
    REMIT_LIST,
    remitList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:REMIT_LIST,
                data
            })
        })
    },
    REMIT_ADD,
    remitAdd : (params)=>{
        params = Object.assign({}, params);
        if(typeof params.time == 'object') {
            params.time = Math.floor(params.time.toDate().getTime()/1000)*1000;
        }
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:REMIT_ADD,
                data
            })
        })
    },
    REMIT_DELETE,
    remitDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:REMIT_DELETE,
                data,
            })
        })
    },
    REMIT_EDIT,
    remitEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:REMIT_EDIT,
                data,
            })
        })
    },
    REMIT_DETAIL,
    remitDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:REMIT_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/RemitAction.js